import { InputAction, LockIcon, LockOpenIcon } from '@gogame/components';

export const LockAction = ({ locked, onLock, fontSize }) => {
  return (
    <InputAction
      icon={locked ? <LockIcon /> : <LockOpenIcon />}
      onClick={onLock}
      tooltip={`${locked ? 'Unlock' : 'Lock'} current value`}
      fontSize={fontSize}
    />
  );
};

export default LockAction;
